import {
  collection,
  doc,
  query,
  getDocs,
  getDoc,
  where,
  orderBy
} from "firebase/firestore";
import { getDateFromTimestamp } from "../../utility/functions";

export async function fetchLearningPath({ db }) {
  try {
    /**
     * Fetch the system settings document. Use this document to
     * find the currently active campaign. Return an empty array
     * if no settings document or active campaign found.
     */

    const settingsRef = doc(db, "system", "settings");
    const settingsDoc = await getDoc(settingsRef);

    const settingsData = settingsDoc.data();
    if (!settingsData || !settingsData.activeCampaign) {
      return [];
    }

    /**
     * Fetch the active campaign document using the settings data
     * returned in the previous query. If no campaign document is
     * found, return an empty array.
     */

    const campaignRef = settingsData.activeCampaign;
    const campaignDoc = await getDoc(campaignRef);
    const campaignData = campaignDoc.data();
    if (!campaignData || !campaignData.title) {
      return [];
    }

    /**
     * Fetch all documents in the learning path collection of the
     * active campign. Loop through document snapshots, extract data.
     */    
    const learningPathDocs = await getDocs(
      query(collection(campaignRef, "learningPath"), orderBy("_sidebarOrder"))
    );

    let learningPath = [];
    learningPathDocs.docs.map((learningPathDoc) => {
      learningPath.push({
        ...learningPathDoc.data(),
        id: learningPathDoc.id,
      });
    });

    /**
     * Return an array of learning path documents.
     */
    return learningPath;
  } catch (error) {
    return {
      error: true,
      message: "Could not fetch learning path data",
    };
  }
}

export async function fetchVideoProgress({ db, user }) {
  return new Promise(async (resolve) => {
    try {
      /**
       * Create a reference to the user progress sub-collection on the
       * user record. Query all progress documents. Return an array of docs.
       */
      const userRef = doc(db, "users", user);
      const progressRef = collection(userRef, "progress");
      
      const q = query(progressRef);      
      const progressDocs = await getDocs(q);
      
      const progressData = [];

      if (progressDocs.docs.length > 0) {
        progressDocs.forEach((progressDoc) => {                  
          let data = progressDoc.data();                       
          data.timestamp = getDateFromTimestamp(data.timestamp)          
          
          progressData.push(data);
        });
      }

      return resolve(progressData);
    } catch (error) {
      console.log(error);
      return resolve(error);
    }
  });
}

export async function fetchQuizProgress({ db, user }) {
  return new Promise(async (resolve) => {
    try {
      /**
       * Create a reference to the user progress sub-collection on the
       * user record. Query all progress documents. Return an array of docs.
       */
      const userRef = doc(db, "users", user);
      const progressRef = collection(userRef, "progress");

      const q = query(progressRef, where("type", "==", "quiz"));      
      const progressDocs = await getDocs(q);
      const progressData = [];

      if (progressDocs.docs.length > 0) {
        progressDocs.forEach((progressDoc) => {
          let data = progressDoc.data();              
          data.timestamp = getDateFromTimestamp(data.timestamp)
          
          progressData.push(data);
        });
      }

      return resolve(progressData);
    } catch (error) {
      console.log(error);
      return resolve(error);
    }
  });
}
